import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import {
    SelectedPlantingAgriField,
    ShippingRecordCollectiveRegisterItem
} from "@/types/Component";
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import SelectPlantingAndAgrifieldSplitShippping from '@/components/Record/SelectPlantingAndAgrifieldSplitShippping/SelectPlantingAndAgrifieldSplitShippping.vue'


type QualityStandardsData = {
    isWpuAvailable: boolean,
    qualityStandardId: string,
    qualityStandardName: string
    quantity: string
    remainingQuantity: string
}

type CollectiveSplitDetails = {
    shippingSplitId: string,
    plantingId: string,
    agriFieldId: string,
    plantingName: string,
    agriFieldName: string,
    quantity: number,
    qualityStandardData: QualityStandardsData[]
}

interface Field {
    id: string;
    name: string;
    plantedArea: number;
}

interface Planting {
    fields: Field[];
}

interface ShippingTarget {
    id: string;
    name: string;
    planting: Planting;
}

@Component({
    components: {
        SelectPlantingAndAgrifieldSplitShippping
    }
})

export default class CollectiveShippingSplitModal extends Vue {
    @Prop({ default: false })
    private showSplitShippingModal!: boolean;

    @Prop()
    private shippingCollectiveRegisterId!: string

    @Prop({ default: false })
    private isSplitRecordSave!: boolean;

    totalShippingSplitQuantity: any
    private showSelectFromPlantingAgriFields = false
    private shippingCollectiveSplitData = []
    shippingCollectiveSplitDetails: CollectiveSplitDetails[] = []
    private selectedShippingTarget: ShippingTarget[] = []
    selectedPlantingId = ''
    selectedCropId = ''
    isWpuAvailableFlag = false
    plantingFieldIds: any = ''
    private apiBaseUrl = '/admin/shipping_record_register_collective'
    shippingCollectiveDetails: any = ""

    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }


    @Watch('showSplitShippingModal')
    spiltShippingModal() {
        if (this.showSplitShippingModal) {
            this.getShippingCollectiveSplit(this.shippingCollectiveRegisterId);
            this.getShippingCollectievRecord(this.shippingCollectiveRegisterId);
        }
    }

    closeModal() {
        if (store.getters.isInputChanged) {
            const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
            if (confirm) {
                this.shippingCollectiveDetails = null;
                this.shippingCollectiveSplitDetails = []
                this.shippingCollectiveRegisterId = ""
                this.$emit('update:showSplitShippingModal', false);
                store.dispatch("doUpdateIsInputChanged", false);
            }
        }
        else{
            this.shippingCollectiveDetails = null;
            this.shippingCollectiveSplitDetails = []
            this.shippingCollectiveRegisterId = ""
            this.$emit('update:showSplitShippingModal', false);
        }
    }

    async getShippingCollectievRecord(id: string) {
        this.$apiClient.doRequest('get', `${this.apiBaseUrl}/shipping_records/${id}`)
            .then((res) => {
                const response = res.shippingRecordCollectiveDetailsItem[0];
                this.shippingCollectiveDetails = toCamel(response) as ShippingRecordCollectiveRegisterItem
            })
            .catch((error) => {
                console.error('Request failed', error);
            });
    }

    private openPlantingAgriFiedsModal(cropId: string, plantingId: string) {
        const formattedShippingTargets: ShippingTarget[] = [];
        if(this.shippingCollectiveSplitDetails.length>0){

        this.shippingCollectiveSplitDetails.forEach(item => {
            const existingTarget = formattedShippingTargets.find(target => target.id === item.plantingId);
            const field = {
                id: item.agriFieldId,
                name: item.agriFieldName,
                plantedArea: 0
            };
            if (existingTarget) {
                if (item.agriFieldId && item.agriFieldName) {
                    existingTarget.planting.fields.push(field);
                }
            } else {
                formattedShippingTargets.push({
                    id: item.plantingId,
                    name: item.plantingName,
                    planting: {
                        fields: item.agriFieldId && item.agriFieldName ? [field] : []
                    }
                });
            }
        });
        const validItems = this.shippingCollectiveSplitDetails.filter(item =>
            item.agriFieldId && item.plantingId && !item.shippingSplitId
        );
        if (validItems.length > 0) {
            this.selectedShippingTarget = formattedShippingTargets.filter(item =>
                validItems.some(validItem => validItem.plantingId === item.id)
            );
        }
       }
        else{
            this.selectedShippingTarget =[]
        }
        this.plantingFieldIds = this.shippingCollectiveSplitDetails
        .filter(item => item.agriFieldId && item.plantingId && item.shippingSplitId)
        .map(item => ({
            plantingId: item.plantingId,
            agriFieldId: item.agriFieldId
        }));
        this.selectedPlantingId = plantingId
        this.selectedCropId = cropId
        this.showSelectFromPlantingAgriFields = true
    }
    commitPlantingAndField(selectedItem: SelectedPlantingAgriField[]) {
        if (!selectedItem) return;
        selectedItem.forEach(item => {
            if (!item.planting || !Array.isArray(item.planting.fields)) return;
            item.planting.fields.forEach(field => {
                const exists = this.shippingCollectiveSplitDetails.some(detail =>
                    detail.plantingId === item.planting.id && detail.agriFieldId === field.id
                );
                if (!exists) {
                    const newItem = {
                        shippingSplitId: '',
                        plantingId: item.planting.id,
                        agriFieldId: field.id,
                        quantity: 0,
                        qualityStandardData: [],
                        plantingName: item.planting.name,
                        agriFieldName: field.name,
                    };
                    this.shippingCollectiveSplitDetails.push(newItem);
                }
            });
        });
        this.shippingCollectiveSplitDetails = this.shippingCollectiveSplitDetails.filter(detail => {
            if (detail.shippingSplitId) {
                return true;
            }
            const isValid = selectedItem.some(item => {
                if (item.planting.id !== detail.plantingId) {
                    return false;
                }
                return item.planting.fields.some(field => field.id === detail.agriFieldId);
            });
            return isValid;
        });
        this.getHarvestRemainingQuantity();
    }

    getShippingCollectiveSplit(id: string) {
        this.$apiClient.doRequest('get', `/admin/collective_shipping_split/${id}`)
            .then(res => {
                this.shippingCollectiveSplitDetails = res.splits.map((split: any) => ({
                    ...split,
                    qualityStandardData: []
                }));
                return this.getHarvestRemainingQuantity();
            })
            .then(() => {
                this.calculateTotalQuantity();
            })
            .catch(error => {
                this.$toasted.error('データの取得に失敗しました。');
            });
    }

    getHarvestRemainingQuantity() {
        const weightUnitId = this.shippingCollectiveDetails?.weightUnitId;

        const promises = this.shippingCollectiveSplitDetails.map(item =>
            this.$apiClient.doRequest('get', `/admin/collective_shipping_split/remainings/${item.plantingId}/${item.agriFieldId}/${weightUnitId || "null"}`)
                .then(res => {
                    this.isWpuAvailableFlag = res.isWpuAvailable
                    if (res.remainings.length) {
                        const formattedString = res.remainings.map((quantity: any) => ({
                            isWpuAvailable: quantity.isWpuAvailable,
                            qualityStandardId: quantity.qualityStandardId,
                            qualityStandardName: quantity.qualityStandardName,
                            quantity: quantity.quantity,
                            remainingQuantity: quantity?.remainingQuantity % 1 > 0.5 ? Math.ceil(quantity.remainingQuantity) : quantity.remainingQuantity
                        }));

                        const matchItem = this.shippingCollectiveSplitDetails.find(
                            splitItem => splitItem.plantingId === res.plantingId && splitItem.agriFieldId === res.agriFieldId
                        );

                        if (matchItem) {
                            matchItem.qualityStandardData = formattedString;
                        }
                    }
                })
                .catch(error => {
                    this.$toasted.error('データの取得に失敗しました。');
                })
        );

        return Promise.all(promises);
    }

    formattedQualityData(details: QualityStandardsData[] | string) {
        if (Array.isArray(details) && details.length === 0) {
            return "---";
        }
        if (typeof details === 'string') {
            return details;
        }

        if (!Array.isArray(details)) {
            return '';
        }
        return details.map(item => {
            let text = '';
            if (!this.isWpuAvailableFlag || !item.isWpuAvailable) {
                text = `${item.qualityStandardName}：<span style="color: red;" class="tooltip">単位未設定(単位未設定)</span>`;
            }
            else {
                const jpHarvestQuantity = Number(item.quantity)?.toLocaleString('ja-JP')
                const jpRemainingQuantity = Number(item.remainingQuantity)?.toLocaleString('ja-JP')
                const selectedWeightUnitName = this.shippingCollectiveDetails?.weightUnitName
                const quantityText = `${jpHarvestQuantity}${selectedWeightUnitName}`;
                const remainingQuantityText = `(${jpRemainingQuantity}${selectedWeightUnitName})`;
                text = `${item.qualityStandardName}：${quantityText}${remainingQuantityText}`;
            }
            return text;
        }).join(' / ');
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ?
            numberToFormat.toLocaleString(undefined, {
                minimumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0,
                maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
            })
            : '';
    }


    validation(): boolean {
        const errmsg: string[] = []
        if (this.shippingCollectiveSplitDetails.length === 0) {
            errmsg.push("分割数量データを追加してください。")
        }
        this.shippingCollectiveSplitDetails.forEach(detail => {
            if (detail.quantity == null || detail.quantity.toString() == '') {
                errmsg.push(`「作付：${detail.plantingName}、圃場：${detail.agriFieldName}」の数量を入力してください`) 
            }
            else {
                const quantityStr = detail.quantity.toString().split('.')
                if(detail.quantity < 0 || quantityStr[0].length > 7 || (quantityStr[1] && quantityStr[1].length > 2)) {
                  errmsg.push(`「作付：${detail.plantingName}、圃場：${detail.agriFieldName}」数量は0以上の整数部7桁小数部2桁までの数値を入力してください`)
                }
            }
        })
        if (this.shippingCollectiveSplitDetails.length > 0 && this.shippingCollectiveDetails.quantity !== Number(this.calculateTotalQuantity().replace(/,/g, '')) ) {
            errmsg.push("出荷数量と分割後の数量が一致していません。");
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    cancelRecord() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }   
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if (this.shippingCollectiveRegisterId != null) {
            this.getShippingCollectiveSplit(this.shippingCollectiveRegisterId);
        }
        else{
            this.shippingCollectiveSplitDetails = []
            this.selectedShippingTarget =[]
        }
    }

    saveRecord() {
        if (!this.validation()) {
            return false
        }
        const shippingCollectiveSplitDetails = this.shippingCollectiveSplitDetails.map(item => {
            return {
                planting_id: item.plantingId,
                agri_field_id: item.agriFieldId,
                quantity: item.quantity
            }
        });

        const data = {
            shipping_record_collective_register_data_id: this.shippingCollectiveRegisterId,
            shipping_record_collective: shippingCollectiveSplitDetails,
        }
        this.$apiClient.doRequest('post', `/admin/collective_shipping_split`, data).then(res => {
            this.$emit('update:isSplitRecordSave', true);
            this.$store.dispatch('doUpdateIsInputChanged', false);
            this.$toasted.success("保存しました。")
            this.closeModal();
        });
    }

    deleteCollectiveSplitDetail(index: number) {
        this.shippingCollectiveSplitDetails.splice(index, 1)
        this.calculateTotalQuantity()
        this.inputChanged();
    }

    calculateTotalQuantity() {
        const total = this.shippingCollectiveSplitDetails.reduce((total, details) => {
            return total + Number((details.quantity || 0));
        }, 0);
        return total.toLocaleString('ja-JP', { maximumFractionDigits: 2});
    }

    @Emit('inputChanged')
    private inputChanged() {
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
}